import { render } from "./RegionDashboardsVES.vue?vue&type=template&id=33cf5536&scoped=true&ts=true"
import script from "./RegionDashboardsVES.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsVES.vue?vue&type=script&lang=ts"

import "./RegionDashboardsVES.vue?vue&type=style&index=0&id=33cf5536&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cf5536"]])

export default __exports__